import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../dr-dish.constants';


@Component({
  selector: 'app-dr-dish-change-password-sent',
  templateUrl: './dr-dish-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './dr-dish-change-password-sent.component.css',
  ],
})
export class DrDishChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
